import { Pipe, PipeTransform } from '@angular/core';
import { StatusWeryfikacjiZgodnosciZOryginalem } from '@interfaces/stypendia/platforma-administratora/enums/status-weryfikacji-zgodnosci-zoryginalem.enum';

@Pipe({
  name: 'statusWeryfikacjiZgodnosciZOryginalemStypendia',
})
export class StatusWeryfikacjiZgodnosciZOryginalemStypendiaPipe implements PipeTransform {
  transform(value: StatusWeryfikacjiZgodnosciZOryginalem): string {
    const { NieSprawdzono, ZgodnyZOryginalem, NieZgodnyZOryginalem } = StatusWeryfikacjiZgodnosciZOryginalem;
    switch (value) {
      case NieSprawdzono:
        return 'bg-warning text-secondary';
      case ZgodnyZOryginalem:
        return 'bg-success';
      case NieZgodnyZOryginalem:
        return 'bg-danger';
      default:
        return 'bg-info';
    }
  }
}
